<template>
  <div class="individualComponent_zk">
    <view-model ref="viewModel"></view-model>
    <el-row>
      <el-col :span="18">
        <el-card
          shadow="always"
          :body-style="{ padding: '20px' }"
          class="indeivLeft"
        >
          <el-row>
            <!-- 树形控件地方 -->
            <el-col :span="6">
              <el-card shadow="never" class="cardbody cardboder">
                <div class="default_btn" v-if="activeName == 1">
                  <el-button size="mini" @click="UpdateUserDefault" class="btn"
                    >默认</el-button
                  >
                </div>
                <el-tabs
                  style="height: 95%"
                  v-model="activeName"
                  @tab-click="handleClick"
                >
                  <el-tab-pane label="按业务" name="1">
                    <div style="float: right">
                      <el-checkbox v-model="treecheckedAll" @change="showAll()"
                        ><span style="font-size: 15px"> 全选</span></el-checkbox
                      >
                    </div>
                    <!-- 树形控件地方 -->
                    <Components-tree
                      ref="tree1"
                      :defaultChecked="
                        userInfo.user22 != null
                          ? userInfo.user22.split(',')
                          : []
                      "
                      :isAllchecked="ztreeAllchecked"
                      @updateIds="updateIds"
                      :treeData="zNodes"
                      v-if="zNodes.length"
                      :item="item"
                    ></Components-tree>
                  </el-tab-pane>
                  <el-tab-pane label="产品构件" name="2">
                    <br />
                    <el-input
                      style="width: 98%; margin-bottom: 20px"
                      placeholder="输入产品关键字搜索"
                      prefix-icon="el-icon-search"
                      v-model="keyword"
                      @input="getbrandTreeList()"
                    ></el-input>
                    <div style="float: right">
                      <el-checkbox
                        v-model="treecheckedAlluser"
                        @change="showAlluser()"
                        ><span style="font-size: 15px"> 全选</span></el-checkbox
                      >
                    </div>
                    <!-- 树形控件地方 -->
                    <Components-tree
                      ref="tree2"
                      :filterId="'1'"
                      @updateIds="updateIds"
                      :isAllchecked="ztreeAllcheckeduser"
                      :treeData="EnzNodes"
                      v-if="EnzNodes.length"
                      :item="Enitem"
                    ></Components-tree>
                  </el-tab-pane>
                </el-tabs>
              </el-card>
            </el-col>
            <!-- 中间部分 -->
            <el-col :span="17" style="margin-left: 15px; width: 72.83333%">
              <el-card shadow="never" class="cardbody cardboder">
                <div class="cardtop">
                  <el-input
                    placeholder="搜索关键词"
                    prefix-icon="el-icon-search"
                    style="width: 150px; margin-left: 70px"
                    size="small"
                    v-model="Allkeyword"
                    @input="updateIds()"
                  ></el-input>
                  <el-button type="text" @click="rotate()">
                    <img
                      :class="{ go: addRotate }"
                      src="@/assets/img/company/revser.png"
                      style="
                        width: 16px;
                        height: 16px;
                        margin-bottom: -3px;
                        margin-left: 10px;
                      "
                    />
                  </el-button>
                </div>
                <el-divider></el-divider>
                <!-- 头部下拉框部分 -->
                <div class="tabletop">
                  <label>排序</label>
                  <el-select
                    placeholder="按最新排序"
                    style="width: 220px"
                    size="small"
                    v-model="povalue"
                    filterable
                    @change="updateIds()"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <label style="margin-left: -70px">软件版本</label>
                  <el-select
                    placeholder="全部"
                    filterable
                    style="width: 280px"
                    v-model="edvalue"
                    @change="updateIds()"
                    size="small"
                  >
                    <el-option
                      v-for="(item, index) in editions"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                  <div class="tablebtnpadding">
                    <el-button
                      type="text"
                      style="padding-left: 40px"
                      @click="exportExcel"
                    >
                      <img
                        src="@/assets/img/用户/fenx.png"
                        style="width: 16px; height: 16px; margin-bottom: 3px"
                      />
                      <span style="font-size: 12px; color: #035dff"
                        >&nbsp;导出</span
                      >
                    </el-button>
                  </div>
                </div>
                <!-- 表格数据部分 -->
                <div class="bottomcontent">
                  <el-table
                    ref="yimultipleTable"
                    v-loading="tableLoading"
                    element-loading-text="构件加载中..."
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    :show-header="false"
                    height="70vh"
                    max-height="660"
                    class="execel"
                  >
                    <el-table-column>
                      <template slot-scope="scope">
                        <!-- 第一行 -->
                        <el-row class="rownoe">
                          <el-col :span="8" style="display: flex">
                            <el-tooltip
                              class="item"
                              effect="light"
                              :content="scope.row.fmif02"
                              placement="top"
                            >
                              <span
                                style="
                                  font-size: 16px;
                                  color: #000;
                                  font-weight: 600;
                                  padding-top: 2px;
                                "
                              >
                                {{
                                  scope.row.fmif02.length > 6
                                    ? scope.row.fmif02.substring(0, 6) + "..."
                                    : scope.row.fmif02
                                }}
                              </span>
                            </el-tooltip>
                            <el-rate
                              disabled
                              v-model="XXvalue"
                              :colors="['#035DFF', '#035DFF', '#035DFF']"
                            ></el-rate>
                          </el-col>
                          <el-col :span="5">
                            <span style="font-size: 16px">{{
                              scope.row.fmif08
                            }}</span>
                          </el-col>
                          <el-col :span="3">
                            <el-button size="mini" class="licol">{{
                              scope.row.name
                            }}</el-button>
                          </el-col>
                          <el-col
                            :span="4"
                            v-if="scope.row.CompanyName != null"
                          >
                            <el-tooltip
                              class="item"
                              effect="light"
                              :content="scope.row.CompanyName"
                              placement="top"
                            >
                              <el-button size="mini" class="licol">
                                {{
                                  scope.row.CompanyName.length > 6
                                    ? scope.row.CompanyName.substring(0, 6) +
                                      "..."
                                    : scope.row.CompanyName
                                }}
                              </el-button>
                            </el-tooltip>
                          </el-col>
                          <el-col
                            :span="2"
                            v-if="
                              activeName != 1 && scope.row.BrandName != null
                            "
                          >
                            <el-button size="mini" class="compnt">{{
                              scope.row.BrandName
                            }}</el-button>
                          </el-col>
                          <el-col :span="2" v-else>&nbsp;</el-col>
                          <el-col :span="2">
                            <div
                              class="tabletnpadding"
                              @click="$refs.viewModel.myshow(scope.row)"
                            >
                              <el-button type="text" style="padding-left: 40px">
                                <img
                                  src="../../../assets/img/company/select2.png"
                                  style="
                                    width: 16px;
                                    height: 16px;
                                    margin-bottom: 3px;
                                  "
                                />
                              </el-button>
                              <span style="font-size: 12px; color: #035dff"
                                >查看</span
                              >
                            </div>
                          </el-col>
                        </el-row>
                        <!-- 第二行 -->
                        <el-row>
                          <el-col :span="4">
                            <el-image
                              style="
                                width: 100px;
                                height: 100px;
                                border: 1px solid #e5e5e5;
                                border-radius: 8px;
                              "
                              :src="$store.state.baseUrl + scope.row.fmif03"
                            ></el-image>
                          </el-col>
                          <el-col :span="20">
                            <el-row style="margin-bottom: 10px">
                              <el-col :span="8">
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="scope.row.model"
                                  placement="top"
                                  style="position: relative; z-index: 99999999"
                                >
                                  <span>
                                    类型：{{
                                      scope.row.model.length > 8
                                        ? scope.row.model.substring(0, 8) +
                                          "..."
                                        : scope.row.model
                                    }}
                                  </span>
                                </el-tooltip>
                              </el-col>
                              <el-col :span="8">
                                <span>材质：{{ scope.row.fmif05 }}</span>
                              </el-col>
                              <el-col :span="8">
                                <span>关键词：{{ scope.row.fmif07 }}</span>
                              </el-col>
                            </el-row>
                            <el-row style="margin-bottom: 10px">
                              <el-col :span="8">
                                <span>精细度：{{ scope.row.fmif04 }}</span>
                              </el-col>
                              <el-col :span="8">
                                <span>
                                  参变联动：{{
                                    scope.row.fmif06 == 0 ||
                                    scope.row.fmif06 == null
                                      ? "否"
                                      : "是"
                                  }}
                                </span>
                              </el-col>
                              <el-col :span="8">
                                <span>描述：{{ scope.row.fmif025 }}</span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :span="24">
                                <span>
                                  {{
                                    scope.row.attamentList != undefined &&
                                    scope.row.attamentList.length > 0
                                      ? "附件：" +
                                        scope.row.attamentList
                                          .map((a) => a.atta03)
                                          .toString()
                                      : ""
                                  }}
                                </span>
                              </el-col>
                            </el-row>
                            <el-row>
                              <el-col :span="16">&nbsp;</el-col>
                              <el-col :span="2" class="have_btn">
                                <el-button type="text" @click="give(scope.row)">
                                  <img
                                    v-if="scope.row.IsThumbs_Up == '1'"
                                    src="@/assets/img/用户/点赞.png"
                                    style="width: 19px; margin-top: -3px"
                                  />
                                  <img
                                    v-else
                                    src="@/assets/img/用户/Group 57.png"
                                    style="margin-top: -3px"
                                  />
                                  <span>&nbsp;{{ scope.row.Thumbs_Up }}</span>
                                </el-button>
                              </el-col>
                              <el-col :span="2" class="have_btn">
                                <el-button
                                  type="text"
                                  @click="mation(scope.row)"
                                >
                                  <img src="@/assets/img/用户/Group 58.png" />
                                  <span>&nbsp;{{ scope.row.commentsum }}</span>
                                </el-button>
                              </el-col>
                              <el-col :span="2" class="have_btn">
                                <el-button
                                  type="text"
                                  @click="Collesta(scope.row)"
                                >
                                  <img
                                    v-if="scope.row.IsCollection == '1'"
                                    src="@/assets/img/用户/Frame-1.png"
                                    style="width: 19px; margin-top: -3px"
                                  />
                                  <img
                                    v-else
                                    src="@/assets/img/用户/Group 60.png"
                                    style="margin-top: -3px"
                                  />
                                  <span>&nbsp;{{ scope.row.connectNum }}</span>
                                </el-button>
                              </el-col>
                              <el-col :span="2" class="have_btn">
                                <el-dropdown
                                  style="margin-top: 9px"
                                  trigger="click"
                                  @command="(val) => download(val, scope.row)"
                                >
                                  <span class="el-dropdown-link">
                                    <img src="@/assets/img/用户/Group 59.png" />
                                    <span>&nbsp;{{ scope.row.downsum }}</span>
                                  </span>
                                  <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="a"
                                      >下载构件</el-dropdown-item
                                    >
                                    <el-dropdown-item
                                      command="b"
                                      v-if="
                                        scope.row.attamentList != null &&
                                        scope.row.attamentList.length
                                      "
                                      >下载文件</el-dropdown-item
                                    >
                                  </el-dropdown-menu>
                                </el-dropdown>
                              </el-col>
                            </el-row>
                          </el-col>
                        </el-row>
                      </template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    class="ppfixed"
                    style="bottom: 20px; left: 38%"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    align="center"
                    background
                  ></el-pagination>
                </div>
              </el-card>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="6">
        <!-- 企业信息 -->
        <el-row>
          <el-card shadow="always" class="Right-top">
            <div slot="header">
              <h5>企业信息</h5>
              <el-divider></el-divider>
            </div>
            <div style="text-align: center">
              <el-avatar :src="Imgsrc"></el-avatar>
              <p>{{ enterinfo.user02 }}</p>
            </div>
            <el-row style="text-align: center; margin-top: 20px">
              <el-col :span="12">
                <img src="@/assets/img/用户/注册员工数.png" alt />
                <span>注册员工数</span>
                <h2>{{ enterinfo.CompanyUserNum }}</h2>
              </el-col>
              <el-col :span="12">
                <img src="@/assets/img/用户/已收录族数.png" alt />
                <span>已记录族数</span>
                <h2>{{ enterinfo.CompanyFamilyNum }}</h2>
              </el-col>
            </el-row>
          </el-card>
        </el-row>
        <!-- 动态 -->
        <el-row>
          <el-card
            v-loading="dynamicLoading"
            element-loading-text="动态加载中..."
            shadow="always"
            class="Right-button"
          >
            <div slot="header">
              <h5>动态</h5>
              <el-divider></el-divider>
            </div>
            <div class="divcard">
              <el-card
                style="margin-bottom: 10px"
                shadow="never"
                class="soncard cardboder"
                v-for="item in dynamictabelList"
                :key="item.pbmg01"
              >
                <img
                  src="@/assets/img/用户/动态消息.png"
                  style="float: left"
                  alt
                />
                <div style="margin-left: 55px">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.pbmg04"
                    placement="top"
                  >
                    <div class="textOverflow">{{ item.pbmg04 }}</div>
                  </el-tooltip>
                  <el-row class="textcol">
                    <el-col :span="6">
                      {{ item.pbmg03 == null ? "系统广播" : item.UserName }}
                    </el-col>
                    <el-col :span="7">
                      <el-tooltip
                        class="item"
                        effect="dark"
                        :content="item.Company"
                        placement="bottom"
                      >
                        <div class="textOverflow">{{ item.Company }}</div>
                      </el-tooltip>
                    </el-col>
                    <el-col :span="11" style="margin-top: 3px">
                      <div class="textOverflow">{{ item.pbmg06 }}</div>
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </div>
          </el-card>
        </el-row>
      </el-col>
    </el-row>
    <!-- 列表评论信息弹窗 -->
    <el-dialog
      :visible.sync="mationdialog"
      width="45%"
      append-to-body
      @close="mationDialogClose"
    >
      <h3 style="text-align: center; font-weight: 400">评论</h3>
      <hr />
      <div>
        <el-input
          placeholder="写下您的想法吧~"
          style="width: 36vw"
          v-model="idea"
        ></el-input>
        <el-button
          type="primary"
          style="background-color: #035dff; margin-left: 20px"
          @click="publish"
          >发表评论</el-button
        >
      </div>
      <el-table :data="CommtableData" height="550" style="width: 100%">
        <el-table-column>
          <template slot-scope="scope">
            <el-row>
              <el-col :span="2">
                <el-avatar
                  :size="50"
                  :src="$store.state.baseUrl + scope.row.UserPhoto"
                ></el-avatar>
              </el-col>
              <el-col :span="21">
                <el-col>
                  <div class="flex">
                    <span style="color: #000">{{ scope.row.UserName }}</span>
                    <span style="color: #838383">{{ scope.row.fmac07 }}</span>
                  </div>
                </el-col>
                <el-col>
                  <span style="color: #838383">{{ scope.row.fmac06 }}</span>
                </el-col>
              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetCompanytreeZTree,
  GetComanybrandZTree,
  GetCompanyfamilyinfoList,
  Addfamilyaction,
  GetCompanyInfo,
  Getpublicmsg,
  FindAllComment,
  UpdateUserDefault,
  Delfamilyaction,
  DownFamilyRvt,
  DownFamilyZip,
  GetVersions,
} from "@/setAxios";
import ComponentsTree from "@/components/componentsTree";
import { mapGetters } from "vuex";
import viewModel from "@/components/viewModel";
import secret from "@/utils/secret";
import * as tools from "@/tools/tool";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  name: "individualComponent_zk",
  components: {
    ComponentsTree,
    "view-model": viewModel,
  },
  data() {
    return {
      options: [
        {
          value: "1",
          label: "按最新排序",
        },
        {
          value: "2",
          label: "按热度排序",
        },
        {
          value: "3",
          label: "按下载量排序",
        },
        {
          value: "4",
          label: "按评论数排序",
        },
        // {
        //   value: "5",
        //   label: "按积分数排序",
        // },
        {
          value: "6",
          label: "按点赞数排序",
        },
      ], //排序下拉框
      povalue: "1", //排序value值
      editions: [], //软件版本下拉框
      edvalue: "", //软件版本value值
      activeName: "1", //Tabs标签页切换
      XXvalue: 3, //星级
      tableData: [], //族文件列表数据
      tableLoading: false, //族文件loading
      currentPage: 1, //当前页
      pageSize: 10, //条数
      total: 0, //总条数
      keyword: "", //tabs关键词搜索
      Allkeyword: "", //card关键字搜索
      //分类树形控件所需值
      zNodes: [],
      item: { name: "tree03", parentName: "tree04", id: "tree01" },
      ids: [],
      //产品树形控件所需值
      EnzNodes: [],
      Enitem: { name: "", parentName: "", id: "" },
      enterinfo: [], //企业信息数据
      Enids: [],
      Imgsrc: "", //企业头像
      dynamictabelList: [], //动态列表数据
      dynamicLoading: false, //动态列表loading
      CommtableData: [], //评论列表数据
      mationdialog: false, //评论弹窗
      idea: "", //评论输入框
      addRotate: false, //重置所需值
      count: 0, //滚动条所需值
      treecheckedAll: false,
      treecheckedAlluser: false,
      ztreeAllchecked: false,
      ztreeAllcheckeduser: false,
    };
  },
  computed: {
    ...mapGetters(["uid", "pid", "userInfo"]),
  },
  watch: {},
  methods: {
    showAll() {
      //this.ztreeAllchecked = this.treecheckedAll;
      // this.$refs.tree1.checkAllNodes(this.treecheckedAll);
      // this.updateIds();
      this.$refs["tree1"].zTeeObj.checkAllNodes(this.treecheckedAll);
      this.updateIds(
        this.$refs["tree1"].zTeeObj.getCheckedNodes(true).map((el) => el.tree01)
      );
    },
    showAlluser() {
      this.$refs["tree2"].zTeeObj.checkAllNodes(this.treecheckedAlluser);
      this.updateIds(
        this.$refs["tree2"].zTeeObj.getCheckedNodes(true).map((el) => el.brnd01)
      );
    },
    async UpdateUserDefault() {
      let deprarms = {
        uid: this.userInfo.user01,
        treeid: this.ids.toString(),
        type: 2,
      };
      await UpdateUserDefault(deprarms);
      this.$message.success("保存成功");
      this.$store.dispatch("upDateUserInfo");
    },
    handleSelectionChange() {},
    //分页的条数发生改变时触发
    handleSizeChange(v) {
      this.pageSize = v;
      this.updateIds();
    },
    //分页的页数发生改变时触发
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateIds();
    },
    //分类树形控件绑数据
    async getCompTreeList() {
      this.tableLoading = true;
      let params = {
        companyId: this.$store.state.pid,
      };
      GetCompanytreeZTree({ params }).then((res) => {
        this.zNodes = res.Data;
        this.tableLoading = false;
      });
    },
    //产品树形控件绑数据
    async getbrandTreeList() {
      this.tableLoading = true;
      let params = {
        companyId: this.$store.state.pid,
        seachword: this.keyword,
      };
      let res = await GetComanybrandZTree({ params });
      if (res.Data.length) {
        this.Enitem.name = "brnd02";
        this.Enitem.id = "brnd01";
      }
      this.EnzNodes = res.Data;
    },
    mationDialogClose() {
      this.updateIds();
    },
    //列表数据
    async updateIds(ids, type) {
      this.tableLoading = true;
      type == undefined ? (type = this.activeName) : "";
      if (this.activeName == "1") {
        ids != undefined ? (this.ids = ids) : this.ids;
      } else {
        ids != undefined ? (this.Enids = ids) : this.Enids;
      }
      let params = {
        companyId: this.pid,
        treeid: type == 1 ? this.ids.join() : "",
        brandId: type == 2 ? this.Enids.join() : "",
        type: this.povalue,
        software: this.edvalue,
        seachword: this.Allkeyword,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        uid: localStorage.uid,
      };
      if (this.activeName == "1") {
        params.brandId = "";
      } else {
        params.treeid = "";
      }
      let res = await GetCompanyfamilyinfoList({ params });
      this.tableData = res.Data.list;
      this.tableLoading = false;
      this.total = res.Data.total;
    },
    //软件版本下拉框数据
    getSoftwaredata() {
      GetVersions().then((res) => {
        this.editions = res.Data;
      });
    },
    //Tabs页切换事件
    handleClick(v) {
      if (v.name == "1") {
        this.updateIds(
          this.$refs.tree1.zTeeObj.getCheckedNodes(true).map((el) => el.tree01),
          1
        );
        this.updateIds();
      } else {
        this.updateIds(
          this.$refs.tree2.zTeeObj.getCheckedNodes(true).map((el) => el.brnd01),
          2
        );
      }
    },
    //获取企业信息数据
    getCompList() {
      let params = {
        companyId: this.$store.state.pid,
      };
      GetCompanyInfo({ params }).then((res) => {
        this.enterinfo = res.Data.list[0];
        this.Imgsrc = this.$store.state.baseUrl + res.Data.list[0].user07;
      });
    },
    //动态列表数据
    dynamicList() {
      let params = {
        type: 2,
        companyid: this.$store.state.pid,
        uid: "",
      };
      this.dynamicLoading = true;
      Getpublicmsg({ params }).then((res) => {
        res.Data.list.forEach((element) => {
          if (element.Company != null) {
            if (element.Company.length > 4) {
              element.newCompany = element.Company.substring(0, 4) + "...";
            } else {
              element.newCompany = element.Company;
            }
          }
        });
        this.dynamictabelList = res.Data.list;
        this.dynamicLoading = false;
      });
    },
    //打开列表评论信息弹窗
    mation(row) {
      this.mationdialog = true;
      this.familyId = row.fmif01;
      this.getCommFind();
    },
    //获取族文件评论数据
    async getCommFind() {
      let params = {
        familyid: this.familyId,
      };
      let res = await FindAllComment({ params });
      this.CommtableData = res.Data.list;
    },
    //评论弹窗中发表评论事件
    async publish() {
      if (this.idea == "") {
        this.$message.warning("赶快写下你的评论吧~");
        return;
      } else {
        let params = {
          fmac01: 0,
          fmac02: localStorage.uid,
          fmac03: this.familyId,
          fmac04: "",
          fmac05: 2,
          fmac06: this.idea,
          fmac07: new Date(),
        };
        let res = await Addfamilyaction(params);
        if (res.Code) {
          this.$message.success("发表成功");
          this.idea = ""; //清空输入框
        } else {
          this.$message.error("发表失败");
        }
        this.getCommFind();
      }
    },
    //构件点赞事件
    async give(row) {
      if (row.IsThumbs_Up == 1) {
        this.$confirm("您已点赞, 是否取消点赞?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            uid: localStorage.uid,
            familyId: row.fmif01,
            type: 1,
          };
          Delfamilyaction(params).then((res) => {
            if (res.Code) {
              this.$message.success("成功取消");
              //刷新列表
              this.$refs.tree1.getIds();
            }
          });
        });
      } else {
        let params = {
          fmac01: 0,
          fmac02: localStorage.uid,
          fmac03: row.fmif01,
          fmac04: 0,
          fmac05: 1,
          fmac06: row.fmif25,
          fmac07: new Date(),
        };
        let res = await Addfamilyaction(params);
        if (res.Code) {
          this.$message.success("点赞成功");
          //刷新列表
          this.$refs.tree1.getIds();
        } else {
          this.$message.success("点赞失败");
          return;
        }
      }
    },
    //构件收藏事件
    async Collesta(row) {
      if (row.IsCollection == 1) {
        this.$confirm("您已收藏, 是否取消收藏?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          let params = {
            uid: localStorage.uid,
            familyId: row.fmif01,
            type: 3,
          };
          Delfamilyaction(params).then((res) => {
            if (res.Code) {
              this.$message.success("成功取消");
              //刷新列表
              this.$refs.tree1.getIds();
            }
          });
        });
      } else {
        let params = {
          fmac01: 0,
          fmac02: localStorage.uid,
          fmac03: row.fmif01,
          fmac04: 0,
          fmac05: 3,
          fmac06: row.fmif25,
          fmac07: new Date(),
        };
        let res = await Addfamilyaction(params);
        if (res.Code) {
          this.$message.success("收藏成功");
          //刷新列表
          this.updateIds(
            this.$refs.tree1.zTeeObj.getCheckedNodes(true).map((el) => el.id)
          );
        } else {
          this.$message.success("收藏失败");
          return;
        }
      }
    },
    //构件下载事件
    async download(name, row) {
      //根据选择的下载类型进行判断
      let params = {
        familyId: row.fmif01,
      };
      let res;
      if (name == "a") {
        res = await DownFamilyRvt(params);
      } else {
        res = await DownFamilyZip(params);
      }
      if (res.Code) {
        tools.download(
          this.$store.state.baseUrl + secret.Decrypt(res.Data.Content),
          res.Data.name
        );
        //刷新列表
        this.updateIds(
          this.$refs.tree.zTeeObj.getCheckedNodes(true).map((el) => el.tree01)
        );
      } else {
        this.$message.error(res.Message);
      }
    },
    //导出表格所用
    exportExcel() {
      // 设置当前日期
      let time = new Date();
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      let name = "企业广场族文件列表" + year + "" + month + "" + day;
      var wb = XLSX.utils.table_to_book(document.querySelector(".execel"));
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          name + ".xlsx"
        );
      } catch (e) {}
      this.daochu = false;
      return wbout;
    },
    //重置
    rotate() {
      this.addRotate = true;
      setTimeout(() => {
        this.addRotate = false;
      }, 1000);
      this.Allkeyword = "";
      this.povalue = "1";
      this.edvalue = "";
      this.updateIds();
    },
    //滚动条自动加载数据
    load() {
      this.count += 2;
    },
  },
  created() {
    this.getCompTreeList();
    this.getbrandTreeList();
    this.getSoftwaredata();
    this.getCompList();
    this.dynamicList();
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
.individualComponent_zk {
  /deep/.el-card__body {
    height: 100%;
  }
  /deep/.el-tabs__content {
    height: 95%;
  }
  /deep/.el-tab-pane {
    height: 100%;
  }
  /deep/ .el-table__body {
    display: inline-block;
    width: 100%;
    tbody {
      display: flex;
      flex-direction: column;
      width: 100%;
      tr {
        display: inline-block;
        width: 100%;
        margin: 8px 0;
      }
    }
    .el-table__cell {
      display: inline-block;
      width: 100%;
    }
  }
  height: 100%;
  .indeivLeft {
    height: 91.3vh;
    .cardbody {
      height: 87.6vh;
      .cardtop {
        float: right;
        margin-top: -10px;
      }
      .tabletop {
        margin-bottom: 10px;
        margin-top: -25px;
        .tablebtnpadding {
          width: 100px;
          float: right;
        }
      }
      .el-divider--horizontal {
        margin: 38px 0;
      }
      .default_btn {
        position: absolute;
        left: 19%;
        top: 30px;
        z-index: 999;
        .btn {
          border-radius: 30px;
          background-color: #f2f4f8;
          border: none;
        }
      }
    }
  }
  .Right-top {
    margin-left: 10px;
    height: 35vh;
    h5 {
      font-weight: bold;
      font-size: 15px;
    }
    h2 {
      font-size: 40px;
      color: #035dff;
      margin-top: 10px;
    }
    .el-avatar {
      width: 120px;
      height: 120px;
      margin-top: -40px;
    }
    img {
      position: relative;
      padding-right: 5px;
      padding-top: -10px;
    }
  }
  .Right-button {
    margin-left: 10px;
    margin-top: 10px;
    height: 55.2vh;
    h5 {
      font-weight: bold;
      font-size: 15px;
    }
    .textcol {
      margin-top: 10px;
      color: #999999;
    }
    .infinite-list {
      height: 45vh;
      width: 20vw;
      margin-top: -30px;
      .infinite-list-item {
        height: 80px;
        margin-bottom: 10px;
      }
    }
  }
  .divcard {
    height: 46vh;
    margin-top: -35px;
    overflow: auto;
    .DtImg {
      float: left;
      position: relative;
    }
  }
  .cardboder {
    border: 1px solid #edeef5;
  }
  .bottomcontent {
    .rownoe {
      .licol {
        border-color: #cddfff;
        border-radius: 25px;
        background-color: #cddfff;
        color: #000;
      }
      .compnt {
        border-color: #cddfff;
        border-radius: 25px;
        background-color: #155fdf;
        color: rgb(255, 255, 255);
      }
      .tabletnpadding {
        width: 92px;
        float: right;
        margin-top: -10px;
        position: relative;
        cursor: pointer;
      }
    }
    //表格样式
    /deep/ .el-table td.el-table__cell {
      border-top: 1px solid #ebeef5;
    }
    /deep/ .el-table .el-table__row > :first-child {
      border-left: 1px solid #ebeef5;
      border-bottom-left-radius: 15px;
      border-top-left-radius: 15px;
    }
    /deep/ .el-table td:last-child {
      border-right: 1px solid #ebeef5;
      border-bottom-right-radius: 15px;
      border-top-right-radius: 15px;
    }
    /deep/ .el-table .el-table__row .cell i {
      font-size: 25px;
    }
  }
  .have_btn {
    span {
      color: #000;
    }
  }
  //输入框样式
  /deep/.el-input {
    width: 60%;
    padding-left: 6px;
  }
  /deep/.el-input__inner {
    background-color: #f2f4f8;
    border-radius: 30px;
    border: none;
  }
  /deep/ .el-input__icon {
    color: #000;
  }
  /deep/.el-input {
    input::-webkit-input-placeholder {
      color: rgb(7, 7, 7) !important;
    }
  }
  //图标样式
  /deep/.el-icon-refresh:before {
    font-size: 20px;
    margin-left: 10px;
    color: black;
  }
  /deep/.el-tabs__item {
    font-size: 15px !important;
    font-weight: 700;
    color: #000;
  }
  /deep/.el-tabs__nav-wrap::after {
    width: 0px;
  }
  /deep/.el-tabs__active-bar {
    background-color: #035dff;
    height: 4px;
    border-radius: 35px;
  }
  /deep/.el-tabs__item.is-active {
    color: #000;
  }
  /deep/.el-divider--horizontal {
    margin: 10px 0;
  }
  .go {
    transform: rotate(-720deg);
    transition: all 1s;
  }
}
</style>